// Copyright (c) 2019 Comsearch, Inc., All rights reserved

export const ELEVATION_SI_BOUNDS = 'Must be between -304.495 and 30,479.695 meters.'
export const ELEVATION_US_BOUNDS = 'Must be between -999 and 99,999 feet.'
